import React from "react";

import { Icon, WrappingIconProps } from "../Icon";

export const MailLIcon = (props: WrappingIconProps) => {
  return (
    <Icon {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2 2L22 2V4.13449L13.1421 7.78186C12.4104 8.08315 11.5893 8.08315 10.8576 7.78186L2 4.13462L2 2ZM2 6.29754L2 16.6667L22 16.6667V6.2974L13.9036 9.63122C12.6841 10.1334 11.3156 10.1334 10.0961 9.63122L2 6.29754ZM0 2C0 0.895429 0.895431 0 2 0H22C23.1046 0 24 0.895431 24 2V16.6667C24 17.7712 23.1046 18.6667 22 18.6667H2C0.89543 18.6667 0 17.7712 0 16.6667V2Z"
      />
    </Icon>
  );
};
